import React from 'react';
import { Container, Text, Group } from '@mantine/core';
import { Link } from 'react-router-dom';
import classes from './Footer.module.css';

export function Footer() {
  return (
    <footer className={classes.footer}>
      <Container size="xl">
        <div className={classes.inner}>
          <Group>
            <Link to="/terms" className={classes.link}>Terms of Use</Link>
            <Link to="/privacy" className={classes.link}>Privacy Policy</Link>
          </Group>
          <Text size="sm" c="dimmed">
            © 2025 Optifyne. All rights reserved.
          </Text>
        </div>
      </Container>
    </footer>
  );
}
